<template>
  <router-link :to="'/courses/' + course.id" class="course-item" tag="a">
    <b-image class="course-image" ratio="4by3" :src="course.image_url">
      <template #placeholder>
        <b-skeleton
            class="skeleton-placeholder"
            height="100%"
        ></b-skeleton>
      </template>
    </b-image>
    <p>{{ course.name }}</p>
    <b-progress v-if="show_progress" :value="course.percentage" format="percent" show-value type="is-link"></b-progress>
  </router-link>

</template>

<script>


export default {
  name: 'CourseItem',
  props: {
    course: {
      type: Object,
      required: true
    },
    show_progress: {
      type: Boolean,
      default() {
        return true
      }
    },
  },
};
</script>
